import styled from "styled-components";

export default styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    grid-gap: 12px;
    justify-items: center;
`;
